import { mapRelationship, mapRelationships } from '@/store/mappers'

export function pairMembershipPriceRows(pair) {
  return mapRelationships(pair.relationships.product_store_membership_prices.data)
    .sort((a, b) => a.id - b.id)
    .map(price => ({ price, tier: mapRelationship(price.relationships.membership_tier.data) }))
    .filter(({ tier }) => tier)
    .map(({ price, tier }) => ({
      priceId: price.id,
      tierId: tier.id,
      name: tier.attributes.tier_name,
      price: (price.attributes.price.cents / 100).toFixed(2),
      subject: price.attributes.subject_to_pricing_tiers,
      available: price.attributes.available_for_membership_tier,
      default: price.attributes.use_default_price
    }))
}
